import {Component, Input} from '@angular/core';
import {StatisticsBlockData} from "../../interfaces/statistics-block-data";
import {ChartComponentData} from "../../interfaces/chart-component-data";
import {PieChartData} from "../../interfaces/pie-chart-data";

@Component({
  selector: 'brt-statistics-block',
  templateUrl: './statistics-block.component.html',
  styleUrls: ['./statistics-block.component.scss']
})
export class StatisticsBlockComponent {

  private readonly itemColorSelection: string[] = ["#2996D2", "#FA2027", "#15A050", "#FBC800", "#2064B4", "#1E5F6E", "#128750", "#3C5FDB", "#0FF0FF"];
  private currentAvailableColor = 0;

  highlightedItemIdx = -1;

  chartData: ChartComponentData = {
    type: "pie",
    data: {
      datasets: []
    } as PieChartData
  }

  pieChartData: PieChartData = {
    datasets: []
  }
  @Input('data') set setData(data: Partial<StatisticsBlockData>) {
    const keys = Object.keys(data);


    console.log('statistics-block', data);
    this.data = {
      ...this.data,
      ...data
    }

    this.data.headlineData = {
      ...this.data.headlineData,
      ...data.headlineData
    };

    this.data.items = this.data.items.map((el) => {
      let color: string = (el.color && el.color.length) ? el.color : this.getAvailableColor();
      return {
        ...el,
        color: color
      }
    });

    this.pieChartData.datasets = [];


    if(this.data.itemsOrder !== "NONE") {
      this.data.items = this.data.items.sort((a, b) => {
        if(a.value > b.value) {
          return this.data.itemsOrder === "ASC" ? 1 : -1;
        }

        if(a.value < b.value) {
          return this.data.itemsOrder === "ASC" ? -1 : 1;
        }

        return 0;
      });
    }

    this.pieChartData.datasets = this.data.items.map((el) => {
      return {
        items: [{label: el.title, value: el.value}],
        color: el.color ?? "",
        label: el.title
      }
    });

    this.chartData.data = this.pieChartData;
  }

  data: StatisticsBlockData = {
    items: [],
    addChart: false,
    headlineData: {},
    itemsOrder: "NONE"
  };

  getAvailableColor(): string {
    const color = this.itemColorSelection[this.currentAvailableColor % this.itemColorSelection.length];
    this.currentAvailableColor++;
    return color;

  }

  onItemChartHovered($event: number) {
    this.highlightedItemIdx = $event;
  }

  onItemChartHoverOut() {
    this.highlightedItemIdx = -1;
  }
}
